import {
  captureException as nativeCaptureException,
  setUser,
  captureUnderscoreErrorException as _captureUnderscoreErrorException,
  captureReactException as _captureReactException,
  captureRequestError as nativeCaptureRequestError,
} from "@sentry/nextjs";

export const captureException = (...args) =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? nativeCaptureException(...args) : null;

export const setSentryUser = (...args) =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? setUser(...args) : null;

export const captureUnderscoreErrorException = (...args) =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? _captureUnderscoreErrorException(...args) : null;

export const captureReactException = (...args) =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? _captureReactException(...args) : null;

export const captureRequestError = (...args) =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? nativeCaptureRequestError(...args) : null;
